export const TIMESTAMP_KEYS = {
  PROFILE_COMPLETED: 'profileCompleted',
  PAYMENT_COMPLETED: 'paymentCompleted',
}
